export function statusCountObjectToString(statusCountObject) {
  let strArray = [];

  if (statusCountObject["ACTIVE"]) {
    strArray.push(`${statusCountObject["ACTIVE"]} Active`);
  }

  if (statusCountObject["MAINTENANCE"]) {
    strArray.push(`${statusCountObject["MAINTENANCE"]} in maintenance`);
  }

  if (statusCountObject["NOT WORKING"]) {
    strArray.push(`${statusCountObject["NOT WORKING"]} not working`);
  }

  return strArray.join("; ");
}
